import React, {useEffect, useMemo} from 'react';
import {useAuth} from "../../../context";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useGetJson, usePostJson} from "../../../hooks";
import {
    endpoints,
    findOverlap2,
    getCurrentTimeString,
    minToVerboseTime,
    repeatType,
    timeStringLocalToUTCMin,
    timeUTCMinToLocalString,
    toggleDays
} from "../../../utils2";
import * as yup from "yup";
import {Alert, Button, ButtonGroup, Form, Stack} from "react-bootstrap";
import {AdminUserAlert, OurAlert, PageTitle, SingleText} from "../../_components";
import {Formik, Form as FormikForm, useFormikContext, Field, FieldArray} from "formik";
import {SetWeeklyField} from "../../feature/_compontents/SetWeekly";
import {SetTimeField} from "../../feature/_compontents/SetTime";
import {WhiteCard} from "../_components/WhiteCard";
import {EventType1, EventType2} from "../../../utils2/maps";


export function AddEditAutomation() {

    const {userId, authToken} = useAuth()
    const {uid, did, tid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (tid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location, tid])

    const edit = tid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(tid === "new" ? null : endpoints.event.get(tid), authToken?.jwt)
    const event = ev?.data
    const config1 = event?.config1
    const index = location.state?.index || event?.config2.index
    const eventType2 = location.state?.event_type2 || event?.event_type2

    const [submitForm, _, loadingAdd, errorEdit, clearErrorEdit] = usePostJson(endpoints.event.edit(tid), authToken?.jwt)

    const validationSchema = yup.object().shape({
        name: yup.string().required("Name is required"),
        repeat: yup.string().required("Repeat type is required"),
        time_start: yup.string()
            .required("Time start is required")
            .test("is-before-stop", "Start time must be before stop time", function (value) {
                const {repeat, time_stop} = this.parent
                if (repeat !== "daily") return true // Skip if not daily
                // if (!value || !time_stop) return true // Let required() handle missing fields
                return value < time_stop
            }),
        time_stop: yup.string()
            .required("Time stop is required"),
        daily: yup.array().of(yup.string()).when("repeat", {
            is: (val) => val !== "weekly",
            then: (schema) => schema.min(1, "At least one day must be selected").required("Daily list is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        weekly_start: yup.string().when("repeat", {
            is: "weekly",
            then: (schema) => schema.required("Day is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        weekly_stop: yup.string().when("repeat", {
            is: "weekly",
            then: (schema) => schema.required("Day is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        overlap: yup.string().test(
            "not-invalid",
            "Invalid field",
            value => value !== "true"),
        // overlap: yup.boolean().transform(val => val === "true" || val === true).oneOf([false], "Overlapping event."),
    })

    const initialValues = {
        name: location.state?.auto?.name || event?.name || "",
        repeat: location.state?.auto?.repeat || config1?.repeat || "daily",
        time_start: timeUTCMinToLocalString(location.state?.auto?.time_start) || timeUTCMinToLocalString(config1?.time_start) || getCurrentTimeString(),
        time_stop: timeUTCMinToLocalString(location.state?.auto?.time_stop) || timeUTCMinToLocalString(config1?.time_stop) || getCurrentTimeString(),
        daily: location.state?.auto?.daily || config1?.daily || [],
        weekly_start: location.state?.auto?.weekly_start || config1?.weekly_start || "",
        weekly_stop: location.state?.auto?.weekly_stop || config1?.weekly_stop || "",
        overlap: location.state?.auto?.overlap || "false",
    }

    function handleOnSubmit(values, action) {
        const convertedValues = {
            ...values,
            time_start: timeStringLocalToUTCMin(values.time_start),
            time_stop: timeStringLocalToUTCMin(values.time_stop)
        }
        const payload = {name: values.name, auto: convertedValues}

        if (edit) {
            submitForm(payload, json => {
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            navigate(location.state.steps[1], {state: {...location.state, ...payload}})
        }
    }

    if (edit && loadingEvent) {
        return <div>Loading...</div>;
    }

    const backTo = -1


    return <Stack>
        <AdminUserAlert/>
        {/*<OurAlert variant="info" show={userId !== uid} msg={`Watch out, you are managing user ID ${uid}.`}/>*/}
        <Alert variant="danger" show={errorEdit} dismissible onClose={clearErrorEdit}>{errorEdit}</Alert>
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>

        <PageTitle title="Set Automation">{edit ? `Edit ${event?.name}` : `Add`}.</PageTitle>


        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm}) => (
                <FormikForm>

                    <WhiteCard>
                        <SingleText name="name" label="Name" placeholder="Event name" maxLength="32"/>
                    </WhiteCard>

                    <RepeatForm/>

                    <SummaryOverlap index={index} event_type2={eventType2}/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={backTo}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>{edit ? "Edit" : "Next"}</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>


    </Stack>

}

export function RepeatForm() {
    const {values, errors, touched} = useFormikContext()

    const RepeatMap = [
        {id: 1, field: "daily", name: "Daily", icon: "bi bi-arrow-repeat", variant: "primary"},
        {id: 2, field: "weekly", name: "Weekly", icon: "bi bi-arrows", variant: "primary"},
        // TODO add always
    ]

    return <div>
        <WhiteCard>
            <div className="">Repeat</div>
            <Stack direction="horizontal" className="my-2" gap={3}>

                <Stack gap={3} className="flex-grow-0">
                    {RepeatMap.map((item) => (
                        <Field name="repeat" key={item.id}>
                            {({field, form}) => (
                                <Button
                                    type="button"
                                    variant={field.value === item.field ? item.variant : `outline-${item.variant}`}
                                    onClick={() => {
                                        form.setFieldValue(field.name, item.field)

                                        if (item.field === "weekly") {
                                            form.setFieldValue("daily", [])
                                        } else if (item.field === "daily") {
                                            form.setFieldValue("weekly_start", "")
                                            form.setFieldValue("weekly_stop", "")
                                        }
                                    }}
                                >
                                    <span className="d-none d-sm-block">{item.name}</span>
                                    <i className={`${item.icon} d-sm-none`}/>
                                </Button>
                            )}

                        </Field>
                    ))}
                </Stack>

                <Stack gap={3}>

                    <FieldArray name="daily">
                        {({push, remove}) => (
                            <div>
                                <ButtonGroup className="d-flex">
                                    {toggleDays.map(day =>
                                        <Button key={day.id} variant={values.daily.includes(day.id) ? day.variant : "outline-" + day.variant}
                                                onClick={() => {
                                                    const isSelected = values.daily.includes(day.id)
                                                    if (isSelected) {
                                                        const index = values.daily.indexOf(day.id)
                                                        // if (index !== -1) remove(index)
                                                        remove(index)
                                                    } else {
                                                        push(day.id)
                                                    }
                                                }}
                                                type="button"
                                                disabled={values.repeat !== "daily"}
                                        >
                                            <span className="d-md-none">{day.short}</span>
                                            <span className="d-none d-md-block d-lg-none">{day.day}</span>
                                            <span className="d-none d-lg-block">{day.long}</span>
                                        </Button>
                                    )}
                                </ButtonGroup>
                                {errors.daily && touched.daily && (
                                    <div className="text-danger">{errors.daily}</div>
                                )}
                            </div>
                        )}
                    </FieldArray>

                    <Stack direction="horizontal" gap={2}>
                        <SetWeeklyField name="weekly_start" value="Start Day" disabled={values.repeat !== "weekly"}/>
                        <SetWeeklyField name="weekly_stop" value="End Day" disabled={values.repeat !== "weekly"}/>
                    </Stack>
                </Stack>

            </Stack>
        </WhiteCard>

        <WhiteCard>
            <div className="my-2">Time</div>
            <Stack direction="horizontal" gap={2}>
                <SetTimeField name="time_start"/>
                <SetTimeField name="time_stop"/>
            </Stack>
        </WhiteCard>
    </div>
}

function SummaryOverlap({index, event_type2}) {
    const {values, setFieldValue, errors, touched} = useFormikContext()
    const {tid, did} = useParams()
    const {authToken} = useAuth()

    const [ev, loadingEv, errorEv, clearErrorEv] = useGetJson(endpoints.event.list(did), authToken?.jwt)
    const events = ev?.data
    const automationEvents = events?.filter(event => event.event_type1 === EventType1.Automation)
    const temp = event_type2 === EventType2.Relay ? automationEvents?.filter(e => e.config2.index === index) : automationEvents

    const eventsFiltered = temp?.filter(event => event.id !== tid)?.map(event => event.config1)

    const summary = useMemo(() => {
        if (values.repeat === repeatType.Daily) {
            if (values.daily.length === 0)
                return {msg: "At least a day must be selected.", invalid: true}
            if (values.time_start === "")
                return {msg: "Select start time.", invalid: true}
            if (values.time_stop === "")
                return {msg: "Select end time.", invalid: true}
            if (timeStringLocalToUTCMin(values.time_start) >= timeStringLocalToUTCMin(values.time_stop))
                return {msg: "End time must be greater than start time.", invalid: true}

            if (eventsFiltered?.length > 0 && findOverlap2(eventsFiltered, {
                repeat: values.repeat,
                daily: values.daily,
                weekly_start: values.weekly_start,
                weekly_stop: values.weekly_stop,
                time_start: timeStringLocalToUTCMin(values.time_start),
                time_stop: timeStringLocalToUTCMin(values.time_stop)
            }))
                return {msg: "Overlapping event.", invalid: true}

            const last = timeStringLocalToUTCMin(values.time_stop) - timeStringLocalToUTCMin(values.time_start)
            return {
                msg: `Event starts every${values.daily.map(day => ` ${day}`)} from ${values.time_start} to ${values.time_stop} (Duration: ${last} min).`,
                invalid: false
            }

        } else if (values.repeat === repeatType.Weekly) {
            if (values.weekly_start === "")
                return {msg: "Select start day.", invalid: true}
            if (values.weekly_stop === "")
                return {msg: "Select end day.", invalid: true}
            if (values.time_start === "")
                return {msg: "Select start time.", invalid: true}
            if (values.time_stop === "")
                return {msg: "Select end time.", invalid: true}

            const startMin = toggleDays.find(day => day.id === values.weekly_start).value * 24 * 60 + timeStringLocalToUTCMin(values.time_start)
            const endMin = toggleDays.find(day => day.id === values.weekly_stop).value * 24 * 60 + timeStringLocalToUTCMin(values.time_stop)
            const diff = startMin <= endMin ? endMin - startMin : endMin - startMin + 7 * 24 * 60
            if (diff === 0)
                return {msg: "Time start and stop must be different.", invalid: true}

            if (eventsFiltered?.length > 0 && findOverlap2(eventsFiltered, {
                repeat: values.repeat,
                daily: values.daily,
                weekly_start: values.weekly_start,
                weekly_stop: values.weekly_stop,
                time_start: timeStringLocalToUTCMin(values.time_start),
                time_stop: timeStringLocalToUTCMin(values.time_stop)
            }))
                return {msg: "Overlapping event.", invalid: true}

            return {
                msg: `Event starts every ${values.weekly_start} at ${values.time_start} and ends every ${values.weekly_stop} at ${values.time_stop} (Duration: ${minToVerboseTime(diff)}).`,
                invalid: false
            }
        } else {
            return {msg: "Unsupported case.", invalid: true}
        }
    }, [values])

    useEffect(() => {
        const value = summary.invalid ? "true" : "false";
        if (values.overlap !== value) {
            setFieldValue("overlap", value, true);
        }
    }, [summary.invalid, values.overlap, setFieldValue]);

    return <div className="my-4">
        <Alert variant="danger" show={errorEv} dismissible onClose={clearErrorEv}>{errorEv}</Alert>
        <Alert variant={summary.invalid ? "danger" : "success"}>
            {/*<div className="fw-semibold fs-5 mb-1">Recap event</div>*/}
            <Stack direction="horizontal" gap={2}>
                {summary.invalid && <i className="bi bi-exclamation-circle fs-4"/>}
                {!summary.invalid && <i className="bi bi-check-circle fs-4"/>}
                {summary.msg}
            </Stack>
        </Alert>
        <Field name="overlap">
            {({field, form}) => (
                <>
                    <Form.Control type="hidden" {...field} />
                    {form.errors.overlap && form.touched.overlap && (<Form.Control.Feedback type="invalid">{form.errors.overlap}</Form.Control.Feedback>)}
                </>
            )}
        </Field>
        {/*<Field name="overlap">*/}
        {/*    {({field, form}) => {*/}
        {/*        const value = summary.invalid ? "true" : "false"*/}
        {/*        if (form.values.overlap !== value) {*/}
        {/*            form.setFieldValue("overlap", value, true); // validate = true*/}
        {/*        }*/}
        {/*        return <>*/}
        {/*            <Form.Control type="hidden" value={value} {...field}/>*/}
        {/*            {form.errors.overlap && form.touched.overlap && (*/}
        {/*                <Form.Control.Feedback type="invalid">*/}
        {/*                    {form.errors.overlap}*/}
        {/*                </Form.Control.Feedback>*/}
        {/*            )}*/}
        {/*        </>*/}
        {/*    }*/}
        {/*    }*/}
        {/*</Field>*/}
        {/*<Field name="overlap">*/}
        {/*    {({field, meta}) => <>*/}
        {/*        /!*<Form.Control type="hidden" value={summary.invalid ? "true" : "false"} {...field}/>*!/*/}
        {/*        <Form.Control type="hidden" value={summary.invalid ? "true" : "false"} {...field}/>*/}
        {/*        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>*/}
        {/*    </>*/}
        {/*    }*/}
        {/*</Field>*/}
    </div>
}